import { motion } from "framer-motion";
import { CountUp } from "@/components/site/CountUp";

const claims = [
  { value: "2x", label: "Faster to market" },
  { value: "2x", label: "More engagement" },
  { value: "2 wks", label: "Kickoff to live" },
];

const fade = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-70px" },
};

export const Authority = () => {
  return (
    <section id="why-gtm" className="relative overflow-hidden bg-ink text-paper border-t border-ink" data-testid="authority-section">
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.06]"
        aria-hidden
        style={{
          backgroundImage:
            "linear-gradient(#fff 1px, transparent 1px), linear-gradient(90deg, #fff 1px, transparent 1px)",
          backgroundSize: "58px 58px",
        }}
      />
      <motion.div
        aria-hidden
        className="pointer-events-none absolute -left-32 top-1/2 h-[90vw] w-[90vw] max-h-[640px] max-w-[640px] -translate-y-1/2 rounded-full border border-white/10"
        animate={{ rotate: 360 }}
        transition={{ duration: 90, ease: "linear", repeat: Infinity }}
      />
      <div
        aria-hidden
        className="pointer-events-none absolute right-0 top-0 font-display font-semibold leading-none text-[28vw] text-white/[0.035] select-none tracking-[-0.06em]"
      >
        2X
      </div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-5 md:px-10 py-14 md:py-20">
        <motion.h2
          {...fade}
          transition={{ duration: 0.6 }}
          className="font-display font-semibold tracking-[-0.02em] text-4xl md:text-5xl lg:text-6xl leading-[0.95] text-paper max-w-4xl text-balance"
        >
          <span className="block">
            <span className="block sm:inline">You have a number</span>{" "}
            <span className="block sm:inline">to hit.</span>
          </span>
          <span className="relative mt-2 inline-block font-editorial italic font-medium text-cobalt">
            We smash it.
            <motion.span
              aria-hidden
              className="absolute left-0 right-0 -bottom-1 h-[3px] origin-left rounded-full bg-[#22C55E]"
              style={{
                boxShadow:
                  "0 0 10px 2px rgba(34, 197, 94, 0.95), 0 0 28px 6px rgba(34, 197, 94, 0.45)",
              }}
              initial={{ scaleX: 0 }}
              whileInView={{ scaleX: 1 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.7, delay: 0.35, ease: [0.22, 1, 0.36, 1] }}
            />
          </span>
        </motion.h2>

        <motion.p
          {...fade}
          transition={{ duration: 0.6, delay: 0.08 }}
          className="mt-5 text-xl md:text-2xl font-light text-white leading-relaxed max-w-2xl text-pretty"
        >
          For B2B companies at $1M+/year looking to scale. Live in two weeks.
        </motion.p>

        <motion.div
          {...fade}
          transition={{ duration: 0.6, delay: 0.14 }}
          className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-6 sm:gap-0 border-t border-white/20"
        >
          {claims.map((c, i) => (
            <div
              key={c.label}
              className={`group pt-8 sm:pr-8 ${i > 0 ? "sm:pl-8 sm:border-l sm:border-white/20" : ""}`}
            >
              <CountUp
                value={c.value}
                className="block font-display font-semibold text-7xl md:text-8xl tracking-tighter leading-[0.82] text-cobalt stat-on-ink transition-transform duration-500 group-hover:scale-[1.04] origin-left"
              />
              <span className="mt-4 block font-mono text-base md:text-lg uppercase tracking-[0.12em] text-paper">
                {c.label}
              </span>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
